import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "../../Common/withRouter"

// users
// import user4 from "../../../assets/images/users/avatar-4.jpg"
import user4 from "../../../assets/images/dummyImg.svg"
import { driver } from "driver.js"
import "driver.js/dist/driver.css"
import { driverList } from "../../../utils/driverJson"
import { createSelector } from "reselect"
import LogoutPopup from "../../VerticalLayout/logoutpopup"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [username, setusername] = useState("Admin")
  const [profile, setProfile] = useState()
  const [logoutModal, setLogoutModal] = useState(false);

  const imgUrl = process.env.REACT_APP_PUSHER

  const driverAccess = useSelector(state => state.DriverGuide.driverAccess)

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.displayName)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        if (obj.username) {
          setusername(obj.username)
        } else {
          setusername(obj.name)
          setProfile(obj?.photo)
        }
      }
    }
  }, [props.success])

  const driverObj = new driver({
    showProgress: true,
    steps: driverList?.series,
  })

  const handleDriverGuide = () => {
    console.log(`clicked`)
    driverObj.drive()
  }
  return (
    <React.Fragment>
      {/* {driverAccess?.history == true ? (
        <div onClick={() => handleDriverGuide()} className="pointer">
          Take a Tour
        </div>
      ) : (
        <></>
      )} */}
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="btn" id="page-header-user-dropdown">
            <img
              className="rounded-circle header-profile-user"
              src={profile != "" ? `${imgUrl}${profile}` : user4}
              alt="Header Avatar"
            />
          </div>
          <span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15 capitalize-letter">
            {username}
          </span>{" "}
          <i className="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i>
            {props.t("View Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" href="/">
            <i className="uil uil-wallet font-size-18 align-middle me-1 text-muted"></i>
            {props.t("My Wallet")}
          </DropdownItem>
          <DropdownItem tag="a" href="#">
            <i className="uil uil-cog font-size-18 align-middle me-1 text-muted"></i>
            {props.t("Settings")}
            <span className="badge bg-soft-success rounded-pill mt-1 ms-2">
              03
            </span>
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="uil uil-lock-alt font-size-18 align-middle me-1 text-muted"></i>
            {props.t("Lock screen")}
          </DropdownItem>
          <div className="dropdown-divider" /> */}
          {loggedUser?.data?.id != 1 && (
            <Link to="/profile" className="dropdown-item">
              <i className="uil uil-user-circle font-size-18 align-middle me-1 text-muted"></i>
              <span>My Profile</span>
            </Link>
          )}
          {loggedUser?.data?.id == 1 && (
            <Link to="/theme-options" className="dropdown-item">
              <i className="uil uil-cog font-size-18 align-middle me-1 text-muted"></i>
              <span>Theme Option</span>
            </Link>
          )}
          <Link to="#" className="dropdown-item"
          onClick={(e) => {
          e.preventDefault();
          setLogoutModal(true);
        }}>
            <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      <LogoutPopup
    isOpen={logoutModal} 
    toggle={() => setLogoutModal(!logoutModal)} 
    router={props.router}
    logout={true}
  />
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
